"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _button = require("../../button");

var _context = require("../../context");

var _icons = require("../../icons");

var _utils = require("../../utils");

var _interfaces = require("../interfaces");

var _constants = require("./constants");

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ChipDismissButton = function ChipDismissButton(_ref) {
  var size = _ref.size,
      chipId = _ref.chipId,
      colorScheme = _ref.colorScheme,
      backgroundColor = _ref.backgroundColor,
      dismissButtonAltText = _ref.dismissButtonAltText,
      dismissButtonRef = _ref.dismissButtonRef,
      onDismiss = _ref.onDismiss;

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      isInHighContrast = _useContext.isInHighContrast;

  var handleDismissKeyUp = function handleDismissKeyUp(e) {
    if (e.key === _utils.EventKeys.ENTER || e.key === _utils.EventKeys.SPACEBAR) {
      onDismiss(_interfaces.ChipDismissTrigger.Keyboard);
    }
  };

  var handleDismissMouseUp = function handleDismissMouseUp() {
    onDismiss(_interfaces.ChipDismissTrigger.Mouse);
  };

  return (0, _core.jsx)(_helperComponents.DismissButton, {
    "aria-describedby": chipId,
    ref: dismissButtonRef,
    icon: (0, _core.jsx)(_icons.IconCross, {
      size: _icons.IconSize.ExtraSmall,
      title: dismissButtonAltText,
      color: isInHighContrast ? 'CanvasText' : _constants.FOREGROUND_COLOR[colorScheme]
    }),
    onKeyUp: handleDismissKeyUp,
    onMouseUp: handleDismissMouseUp,
    variant: _button.ButtonVariant.Tertiary,
    colorScheme: colorScheme === _interfaces.ChipColorScheme.Default ? _button.ButtonColorScheme.Default : _button.ButtonColorScheme.DarkBackground,
    backgroundColor: backgroundColor,
    chipSize: size
  });
};

var _default = ChipDismissButton;
exports.default = _default;